import React from 'react';
import styled from 'styled-components';
import { startCase } from 'lodash-es';

import { DefaultNavigationItemContentProps } from './types';

const StyledValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 0.666666667rem;
`;

const StyledValue = styled.span`
  word-break: break-word;

  &:not(:last-child) {
    margin-bottom: 0.416666667rem;
  }
`;

const renderValues = (values: DefaultNavigationItemContentProps['values']) => (
  Object.entries(values).map(([key, value]) => {
    if (!value) {
      return null;
    }

    return (
      <StyledValue key={`${key}-${value}`}>
        {startCase(value)}
      </StyledValue>
    );
  })
);

const DefaultNavigationItemContent = ({ values }: DefaultNavigationItemContentProps) => (
  <StyledValueWrapper>
    {renderValues(values)}
  </StyledValueWrapper>
);

export default DefaultNavigationItemContent;
